import React from 'react';
import Form from '../form/Form';
import FieldGroup from '../field_group/FieldGroup';
import { requiredValidator } from '../field_group/validators';
import { getErrorValue } from '../../utils/utility';

export default class DuplicateDetail extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = undefined;
  }

  getItemData() {
    return this.formRef.getFormData();
  }

  render() {
    const { label, disabled, fieldErrors, ...otherAttr } = this.props;
    const customAttr = { disabled };
    return (
      <Form
        {...otherAttr}
        showThumbnail={false}
        ref={ref => this.formRef = ref}
        errorMessage={getErrorValue(fieldErrors, 'detail')}
      >
        <FieldGroup
          id="duplicate-name"
          field="name"
          type="text"
          label={label}
          value={''}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'name')}
          {...customAttr}
        />
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/duplicate/DuplicateDetail.js